<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Thẩm định sản phẩm</div>
      </div>
      <div class="card card-w-title" v-if="$myConstants.checkRoleGroup('appraisal_product', 'view_detail')">
        <div class="box-top-list format-top">
          <span class="p-m-0 format-title">Chi tiết yêu cầu thẩm định</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
          </span>
        </div>
        <div class="box-info p-fluid p-grid">
          <div class="p-col-5">
            <div class="box-info-title">Thông tin yêu cầu thẩm định</div>
            <div class="form-info">
              <div class="p-field">
                <label>Mã dịch vụ</label>
                <span>{{ serviceCode }}</span>
              </div>
              <div class="p-field">
                <label> Đơn vị yêu cầu</label>
                <span>{{ organizationRequestText }}</span>
              </div>
              <div class="p-field">
                <label>Đơn vị thẩm định</label>
                <span>{{ organizationAppraisalText }}</span>
              </div>
              <div class="p-field">
                <label>Số lượng yêu cầu</label>
                <span> {{ numberAppraisal }} sản phẩm</span>
              </div>
              <div class="p-field">
                <label>Thời gian tiếp nhận</label>
                <span>{{ createDateText }}</span>
              </div>
              <div class="p-field">
                <label>Nhân viên tiếp nhận</label>
                <span>{{ userCreateText }}</span>
              </div>
              <div class="p-field">
                <label>Trạng thái xử lý</label>
                <span v-html="statusText"></span>
              </div>
            </div>
          </div>
          <div class="p-col-6 p-offset-1">
            <div class="box-info-title">Ghi chú</div>
            <div class="form-info" >
              <textarea v-model="note" disabled rows="13" class="form-control"></textarea>
            </div>
          </div>
        </div>
        <div class="box-info list-product">
          <div class="box-info-title">Danh sách các sản phẩm yêu cầu thẩm định</div>
          <div class="list-data">
            <BaseCommon v-if="dataModel"
              :key="componentKey"
              :listData="listDataProduct"
              :model="dataModel"
              :isFilter="false"
              :labelHeaderAction="'Chi tiết'"
              :pagination="false"
              :isCheckBox="enableButton"
              :arrCheckBoxHidden="arrCheckBoxHidden"
              :actions="getRowActions()"
              @row-select="onRowSelected"
              @row-select-all="onRowSelectedAll"
              v-on:action-click="onActionClicked"
            ></BaseCommon>
            <span v-if="lstProducts && lstProducts.length == 0 && submitData" class="txt-right custom-error">Vui lòng chọn sản phẩm</span>
          </div>
          <div :class="'btn-function'" v-if="enableButton && $myConstants.checkRoleGroup('appraisal_product', 'action_approve')">
            <Button :label="'Duyệt'" @click="acceptVerify"/>
            <Button class="p-button-warning"  :label="'Không duyệt'" @click="rejectVerify"/>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      :header="'Thẩm định'"
      class="dialog-reject popup-dialog"
      :key="componentAcceptKey"
      :visible.sync="showAcceptDialog"
      :contentStyle="{overflow: 'visible'}"
      :style="{width: '50vw'}"
      :modal="true"
    >
      <div class="dialog-content">
        <p class="txt-center"><span class="approval-title">Xác nhận duyệt</span></p>
        <div class="p-fluid">
            <div class="p-col-12 form-popup-custom">
              <div class="p-field txt-center">
                <span class="info-confirm">Bạn có chắc chắn muốn khôi phục thời hạn bảo hành các serial number</span>
                <span v-html="serialnumberText"></span>
              </div>
            </div>
            <div class="p-col-12 form-popup-custom">
              <div class="p-field">
                <label><b>Ghi chú</b></label>
              </div>
              <div class="p-field">
                <Textarea placeholder="Nhập nội dung ghi chú" v-model="noteAccept" :autoResize="true" rows="2"/>
              </div>
            </div>
        </div>
      </div>
      <template
        #footer
      >
        <Button label="Đồng ý" @click="acceptAction()" />
        <Button label="Huỷ" class="p-button-danger"  @click="closeAccept"/>
      </template>
    </Dialog>

    <Dialog
      :header="'Thẩm định'"
      class="dialog-reject popup-dialog"
      :key="componentRejecttKey"
      :visible.sync="showAcceptDialogReject"
      :contentStyle="{overflow: 'visible'}"
      :style="{width: '50vw'}"
      :modal="true"
    >
      <div class="dialog-content">
        <p class="txt-center"><span class="approval-title">Xác nhận không duyệt</span></p>
        <div class="p-fluid">
            <div class="p-col-12 form-popup-custom">
              <div class="p-field txt-center">
                <span class="info-confirm">Bạn có chắc chắn không muốn khôi phục thời hạn bảo hành các serial number</span>
                <span v-html="serialnumberText"></span>
              </div>
            </div>
            <div class="p-col-12 form-popup-custom">
              <div class="p-field">
                <label><b>Hướng xử lý sản phẩm </b><span class="error">*</span> <span class="error solution-error" v-if="solution == 0 && rejectSubmit">Chọn hướng xử lý cho sản phẩm</span></label>
              </div>
              <div class="p-field">
                <div class="p-field-radiobutton">
                  <RadioButton id="radio1" name="solution" value="1" v-model="solution" />
                  <label for="radio1">Từ chối và gửi trả sản phẩm cho đại lý</label>
                </div>
                <div class="p-field-radiobutton">
                  <RadioButton id="radio2" name="solution" value="2" v-model="solution" />
                  <label for="radio2">Sản phẩm cần được sửa chữa</label>
                </div>
                <div class="p-field-radiobutton">
                  <RadioButton id="radio3" name="solution" value="3" v-model="solution" />
                  <label for="radio3">Hủy sản phẩm và đổi sản phẩm mới</label>
                </div>
              </div>
            </div>
            <div class="p-col-12 form-popup-custom">
              <div class="p-field">
                <label><b>Ghi chú</b></label>
              </div>
              <div class="p-field">
                <Textarea placeholder="Nhập nội dung ghi chú" v-model="noteReject" :autoResize="true" rows="2"/>
              </div>
            </div>
        </div>
      </div>
      <template
        #footer
      >
        <Button label="Đồng ý" @click="acceptReject()" />
        <Button label="Huỷ" class="p-button-danger"  @click="closeReject"/>
      </template>
    </Dialog>

    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="popup_confirm.showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
        @hide="hide_comfirm_popup"
    >
      <div class="box_body_popup" >
        <div >
          <!--<div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
          --><p class="p_title_1" style="text-align: center;font-weight: 700; font-style: normal; font-size: 20px;">Tạo dịch vụ sửa chữa thành công</p>
          <p class="p_title_1" style="text-align: left;margin: 16px 0px;">Serial number <span v-for="(item_p, index_p) in popup_confirm.list_serial_number_popup" :key="item_p"><span style="font-weight: 700; color: #0099FF;">{{item_p}}</span>{{ (index_p == (popup_confirm.list_serial_number_popup.length -1 )) ? '':', ' }}</span> đã được tạo dịch vụ sửa chữa</p>
          <p class="p_title_1" style="text-align: left">Mã dịch vụ: <span style="font-weight: 700; color: #000000;">{{ popup_confirm.code_warranty_repair }}</span></p>
          <div class="box_btn">
            <!--icon="pi pi-chevron-circle-right"-->
            <Button
                iconPos="right"
                class="btn-custom"
                :label="'Xem phiếu sửa chữa'"
                type="button"
                @click="redirect_warranty_repair"
            > </Button>
          </div>
        </div>
        <!--<div v-if="creenConfirmDialog == 'export_err'">
          <div class="box_title_err"><img class="img_noti" :src="err_massage_img" /><span class="title_noti" style="">Thất bại</span></div>
          <p class="p_title_1" style="text-align: left">Quá trình xuất dữ liệu báo cáo <span style="font-weight: 700;">Kích hoạt bảo hành sản phẩm</span> đã xảy ra vấn đề. Bạn vui lòng thực hiện lại thao tác xuất dữ liệu.</p>
        </div>-->
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Thông báo</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
import $ from 'jquery'
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      listData: [],
      dataModel: null,
      listDataProduct: [],
      componentKey: Math.random()*100,
      serviceCode: '',
      organizationRequestText: '',
      organizationAppraisalText: '',
      numberAppraisal: 0,
      createDateText: '',
      userCreateText: '',
      statusText: '',
      note: '',
      enableButton: false,
      lstProducts: [],
      submitCheck: false,
      showAcceptDialog: false,
      componentAcceptKey: Math.random()*560,
      noteAccept: '',
      serialnumberText: '',
      componentRejecttKey: Math.random()*260,
      showAcceptDialogReject: false,
      noteReject: '',
      solution: 0,
      rejectSubmit: false,
      arrCheckBoxHidden: ['current_status'],
      submitData: false,
      popup_confirm:{
        list_serial_number_popup:[],
        code_warranty_repair:"",
        showConfirmDialog:false,
        warranty_repair_id:null
      }
    }
  },
  async mounted () {
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      this.id = Number(this.$route.params.id);
      this.initData();
    }
  },
  methods: {
    hide_comfirm_popup(){
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      window.location.reload();
    },
    redirect_warranty_repair(){
      this.$router.push('/admin/warranty-repair/function/'+this.popup_confirm.warranty_repair_id);
    },
    initData() {
      setTimeout(async () => {
        //if (this.checkVisible('warranty_activation', 'view')) {
          await this.initParams();
        // }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      await this.getData(this.id);
      await this.getDataProduct(this.id);
      if (this.enableButton) {
        $('.checkbox-hidden').each(function() {
          if ($(this).val() !== 'checkbox-1') {
            $(this).closest('tr').find('td:first-child').html('');
          }
        });
      }
      this.$store.commit('setLoading', false);
    },
    async settingReasonReject() {
      var variables = {
        where_key: {
          status: {'_in': [1] },
          reason_type: {'_eq': 'not_accepted'}
        },
        orderBy: {
          ordering: 'asc'
        }
      }
      var data = await DataServices.getList('setting_reason_reject', {"variables": JSON.stringify(variables), "fields": "id code reason_name  reason_type is_add_note is_change_product"});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null) {
        for (let index = 0; index < list.length; index++) {
          const ele = list[index];
          this.reasonTypes.push({name: ele.reason_name , value: ele.id, is_add_note: ele.is_add_note, is_change_product: ele.is_change_product, code: ele.code, reason_type: ele.reason_type});
        }
      }
    },
    
    async getData(id) {
      var modelName = 'appraisal';
      var variables = {
        where_key: {
          id: {'_eq': id }
        }
      }
      var data = await DataServices.getList(modelName, {"variables": JSON.stringify(variables), 'fields': 'code note created_date status users {id full_name } appraisal_organization {id name } request_organization {id name } appraisal_product_total_aggregate { aggregate { count } }'});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null && Object.keys(list).length > 0) {
        var records = list[0];
        this.listData = records;
        this.serviceCode = records.code;
        this.note = records.note;
        this.createDateText = moment.tz(records.created_date, this.$myConstants.timeZone()).format('DD/MM/YYYY HH:mm');

        this.organizationRequestText = (records.request_organization != undefined && records.request_organization != null && records.request_organization.name != undefined) ? records.request_organization.name : '';
        this.organizationAppraisalText = (records.appraisal_organization != undefined && records.appraisal_organization != null && records.appraisal_organization.name != undefined) ? records.appraisal_organization.name : '';

        this.numberAppraisal = (records.appraisal_product_total_aggregate !== undefined && records.appraisal_product_total_aggregate !== null) ? records.appraisal_product_total_aggregate.aggregate.count  :  0;
        this.userCreateText = (records.users != undefined && records.users != null && records.users.full_name != undefined && records.users.full_name != null) ? records.users.full_name : '';

        this.enableButton = records.status > 0 ? false : true;
        if (records.status == 0) this.statusText = '<abbr style="font-style: normal; padding: 2px 10px; border-radius: 5px; color:#fff; background: rgba(153, 0, 204, 1); ">Chờ xử lý</abbr>';
        else if (records.status == 1) this.statusText = '<abbr style="font-style: normal; padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(0, 0, 204);">Đã xử lý</abbr>';
      }
    },
    async getDataProduct(id) {
      var name = 'appraisal_product_approval';
      var variables = {
        where_key: {
          appraisal_id: {'_eq': id }
        }
      }
      var data = await DataServices.getList(name, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(name);
      this.dataModel.processData(list);
      this.listDataProduct = list;
      this.componentKey = Math.random()*100;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.rows = function (rowData) {
        var buttons = {}
        buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/appraisal-product/view-detail`}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        
        case 'view':
          this.$router.push(action.path + '/' + data.data.request_return_product_id)
          break;
      }
    },
    onRowSelectedAll(data) {
      this.submitData = false;
      this.lstProducts = data;
    },
    onRowSelected(data) {
      this.submitData = false;
      this.lstProducts = data;
    },
    acceptVerify() {
      this.submitData = true;
      if (this.lstProducts.length  > 0) {
        this.serialnumberText = '';
        for (let index = 0; index < this.lstProducts.length; index++) {
          var item = this.lstProducts[index];
          this.serialnumberText += this.serialnumberText.length > 0 ? '<b>,</b> ' : '';
          this.serialnumberText += '<abbr> ' + item.serialNumber + '</abbr>';
        }
        this.showAcceptDialog = true;
      }
    },
    closeAccept() {
      this.showAcceptDialog = false;
    },
    async updateAppraisal() {
      var name = 'appraisal_product_approval';
      var isApprovalAll = false;
      var variables = {
        where_key: {
          appraisal_id: {'_eq': this.id },
          current_status: {'_in': [0, 1]}
        }
      }
      var data = await DataServices.getList(name, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null && Object.keys(list).length > 0) {
        isApprovalAll = true;
      }
      if(!isApprovalAll) {
        await DataServices.updateData('appraisal', {"variables": JSON.stringify({data_update: {status: 1}, where_key: {id: {'_eq': this.id } } })});
      }
    },
    async acceptAction() {
      var vm =this;
      if(this.lstProducts.length  > 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var k = 0;
        var stop = false;
        var list_object_id = [];
        while (k < this.lstProducts.length) {
          list_object_id.push(this.lstProducts[k].request_return_product_id);
            await this.processAccept(this.lstProducts[k]);
            if (k == (this.lstProducts.length - 1)) {
                stop = true;
            }
            k++;
        }
        this.$store.commit('setLoading', false);
        if (stop) {
          await this.updateAppraisal();
          //Update hủy kế hoạch bảo trì định kỳ
          await this.processCancelPlanOnly(this.lstProducts);
          await vm.$coreService.sendPushNotification('appraisal_warranty_recovery',list_object_id)
          this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Thẩm định thành công', life: 3000 })
          window.location.reload();
          // this.$router.push({path: '/admin/appraisal-product'});
        }
      }
    },
    async processCancelPlanOnly(lstProducts) {
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      var vm = this;
      var list_serial_number_id = [];
      for (var i=0;i<lstProducts.length;i++){
        list_serial_number_id.push(lstProducts[i].serial_number_id);
      }
      //Tìm serail có trạng thái  “Kế hoạch” (giá trị = 0) hoặc “Cần bảo trì” (giá trị = 1)
      var whereKeyMaintence = {
        serial_number_id: {_in: list_serial_number_id},
        process_status: {_in: [this.$dataCommon.MAINTENANCE.PROCESS_STATUS.PLAN,this.$dataCommon.MAINTENANCE.PROCESS_STATUS.MAINTENANCE_NEEDED]}
      }
      var variablesMaintence = {
        where_key: whereKeyMaintence,
        orderBy: {
          parts_number: 'asc',
        }
      }
      var data = await DataServices.getList('maintenance', {"variables": JSON.stringify(variablesMaintence)});
      var listMaintence = data[Object.keys(data)];
      var list_id_maintence = [];
      if (listMaintence.length > 0){
        for (var m=0;m<listMaintence.length;m++){
          list_id_maintence.push(listMaintence[m].id);
        }
        await vm.$coreService.updateStatusMaintence(vm.$dataCommon.MAINTENANCE.PROCESS_STATUS.CANCEL_PLAN_ONLY,list_id_maintence,vm.$store.getters.fullname.id,creator_organization_id);
      }
    },
    async processCreateWarrantyRepair() {
      var vm = this;
      var appraisalData = this.listData;
      var list_product_serial = this.lstProducts;
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      var receive_sender = 1;//default NV đại lý
      var receive_user_id = (!this.$myConstants.isEmpty(appraisalData.users)) ? appraisalData.users.id:null;
      var receive_organization_id = (!this.$myConstants.isEmpty(appraisalData.appraisal_organization)) ? appraisalData.appraisal_organization.id:null;
      var params = {
        receive_day_reception: this.$myConstants.convertDate(moment().format('DD/MM/yyyy')),
        receive_sender: receive_sender,
        receive_method: 0,//default tại TT bảo hành
        receive_note: "",
        process_status: 2,//chờ thực hiện
        status: 1,
        modifier_id: this.$store.getters.fullname.id,
        creator_organization_id: creator_organization_id,
        creator_id: this.$store.getters.fullname.id,
        modified_date: this.$myConstants.currentDate(),
        created_date: this.$myConstants.currentDate(),
      }
      params.receive_user_id = receive_user_id;
      if (receive_sender == 1){
       params.receive_organization_id = receive_organization_id;
      }
      //default người gửi
      params.delivery_return_appointment_day = this.$myConstants.convertDate(moment().format('DD/MM/yyyy'));
      params.delivery_method = 0;
      params.delivery_relative_receiving = 0;
      params.delivery_user_id = receive_user_id;
      params.delivery_organization_id = receive_organization_id;

      params.code = await this.$coreService.getCodeNextWarrantyRepair();
      var list_data_product_insert = [];
      var str_serial_number = "";
      if (list_product_serial.length > 0) {
        for (var i = 0; i < list_product_serial.length; i++) {
          this.popup_confirm.list_serial_number_popup.push(list_product_serial[i].serialNumber);
          var item_product = list_product_serial[i];
          var serial_number = (!this.$myConstants.isEmpty(item_product.serialNumber)) ? item_product.serialNumber:'';
          str_serial_number += (i == (list_product_serial.length - 1)) ? "#" + serial_number + "#" : "#" + serial_number+"#,";
          var object_info_product = await this.$coreService.getSerialWarrantyActivationBySerial(serial_number);
          var itemDataInsert = {
            serial_number_id: (!this.$myConstants.isEmpty(list_product_serial[i].serial_number_id)) ? list_product_serial[i].serial_number_id:null,
            process_status: 0,//chờ thự hiện
            type_service: this.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.REPAIR_APPRAISAL,
            desc_status_product: null,
            status: 1,
            modifier_id: this.$store.getters.fullname.id,
            creator_id: this.$store.getters.fullname.id,
            modified_date: this.$myConstants.currentDate(),
            created_date: this.$myConstants.currentDate(),
            request_return_product_id: list_product_serial[i].request_return_product_id,//lưu thêm để khôi phục bảo hành gửi push
          }
          if (!this.$myConstants.isEmpty(object_info_product)){
            itemDataInsert.serial_user_id = (object_info_product.user_id) ? object_info_product.user_id:null;
            var obj_customer = {
              id:(object_info_product.user_id) ? object_info_product.user_id:null,
              full_name:(object_info_product.full_name) ? object_info_product.full_name:"",
              phone_number:(object_info_product.phone_number_root) ? object_info_product.phone_number_root:null,
              customer_type:(object_info_product.customer_type) ? object_info_product.customer_type:"",
            };
            itemDataInsert.info_customer_product_serial_number = JSON.stringify(obj_customer);
          }
          list_data_product_insert.push(itemDataInsert);
        }
      }
      params.list_serial_number = str_serial_number;
      params.arr_warranty_repair_product_serial_number = {data: this.$myConstants.convertJsonObject(list_data_product_insert)};
      await DataServices.insertData('warranty_repair_detail', {"variables": JSON.stringify({objects: params})}).then(async (resdata) => {
        if (!vm.$myConstants.isEmpty(resdata.insert_core_warranty_repair)){
          if (!vm.$myConstants.isEmpty(resdata.insert_core_warranty_repair.returning[0])) {
            var object_warranty_repair = resdata.insert_core_warranty_repair.returning[0];
            var warranty_repair_id = resdata.insert_core_warranty_repair.returning[0].id;
            vm.popup_confirm.code_warranty_repair = (object_warranty_repair) ? object_warranty_repair.code:'';
            vm.popup_confirm.warranty_repair_id = warranty_repair_id;
            //Lấy danh sách id đề thêm lịch sử cập nhật
            var arr_wr_psn = resdata.insert_core_warranty_repair.returning[0].arr_warranty_repair_product_serial_number;
            var list_wr_product_serial_number_id = [];
            for (var k=0;k<arr_wr_psn.length;k++){
              list_wr_product_serial_number_id.push(arr_wr_psn[k].id);
            }
            await vm.$coreService.updateHistoryWarrantyRepairProductSn('Tiếp nhận dịch vụ',list_wr_product_serial_number_id,0,vm.$store.getters.fullname.id);
            //thêm lịch sử trạng thái sửa chữa
            //await vm.insertProcessWR(warranty_repair_id,2);
            await vm.$coreService.insertProcessWR(warranty_repair_id,2,vm.$store.getters.fullname.id,creator_organization_id);
          }
        }//this.$store.commit('setLoading', true);
      }).catch(async (err) => {
        console.log("errerrerrerr:",err)
        vm.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
          life: 3000
        });
        vm.submitForm = false;
      });
    },
    async processAccept(info) {
      var appraisalID = info.appraisal_id;
      var serialNumberID = info.serial_number_id;
      var returnProductID = info.request_return_product_id;
      var requestActivationID = 0;
      if(info.request_return_product != undefined && info.request_return_product != null &&
      info.request_return_product.request_activation_id != undefined && info.request_return_product.request_activation_id != null) {
        requestActivationID = info.request_return_product.request_activation_id;
      }
      var noteContent = 'Khôi phục trạng thái bảo hành sản phẩm. ' + this.noteAccept;
      var variables = {
        where_key: {
          appraisal_id: {'_eq': appraisalID},
          serial_number_id: {'_eq': serialNumberID}
        },
        data_update: {
          current_status: 5, // đã duyệt
          note: noteContent,
          modified_date: this.$myConstants.currentDate()
        } 
      }
      var returnData  = await DataServices.updateData('appraisal_product', {"variables": JSON.stringify(variables)});
      if (returnData != null) {
        var checkData = returnData[Object.keys(returnData)];
        if (checkData.affected_rows > 0) {
          var returning = checkData.returning[0];
          var appraisalProductID = returning.id;
          await DataServices.updateData('product_serial_number', {"variables": JSON.stringify({data_update: {warranty_status: 5}, where_key: {id: {'_eq': serialNumberID } } })});
          if (serialNumberID > 0 && requestActivationID > 0) {
            await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: {warranty_status: 5}, where_key: {serial_number_id: {'_eq': serialNumberID }, request_activation_id: {'_eq': requestActivationID} } })});
            await this.updateSerialNumberAndRequest(requestActivationID, serialNumberID, 5);
          }
          if (returnProductID > 0) {
            await DataServices.updateData('request_return_product', {"variables": JSON.stringify({data_update: {current_status: 5}, where_key: {id: {'_eq': returnProductID}}})});
          }
          
          var paramsProductProcess = {
              request_return_product_id: returnProductID,
              user_id: this.$store.getters.fullname.id,
              return_status: 5,
              note: noteContent,
              created_date: this.$myConstants.currentDate(),
              modified_date: this.$myConstants.currentDate(),
              warranty_status: 5,
              appraisal_product_id: appraisalProductID
          }
          var returnDataprocess  = await DataServices.insertData('request_return_product_process', {"variables": JSON.stringify({objects: paramsProductProcess})});
          if (returnDataprocess != null) {
            var checkDataprocess = returnDataprocess[Object.keys(returnDataprocess)];
            return checkDataprocess.affected_rows > 0;
          }

        }
      }
      return false;
    },
    async updateSerialNumberAndRequest(requestActivationID, serialNumberID, warrantyStatus) {
      // cập nhật trạng thái bảo hành cho request tạo kích hoạt bảo hành
      var whereKey = { request_activation_id: {'_eq': requestActivationID }, serial_number_id: {'_eq': serialNumberID } }
      var paramsUpdate = { modified_date: this.$myConstants.currentDate(), warranty_status: warrantyStatus}
      await DataServices.updateData('request_activation_product_serial', {"variables": JSON.stringify({data_update: paramsUpdate, where_key: whereKey})});

      var organizationUser = 0;
      var organization = this.$myConstants.organizationUserLogin();
      if (organization != null) organizationUser = organization.id;
      var variablesSerial = {
        where_key: {
          serial_number_id: {'_eq': serialNumberID },
          status: {'_eq': 1}
        }
      }
      var dataSerial = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variablesSerial), "fields": "serial_number_id product_id request_activation_id customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit is_returnable returnable_time  returnable_unit change_time change_unit is_manually_verification last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form product_serial_number { serial_number warranty_status production_status production_order_code product_id status product { warranty_time warranty_unit returnable_time returnable_unit change_time change_unit is_manually_verification } }"});
      var listSerial = dataSerial[Object.keys(dataSerial)];
      if (listSerial != null && listSerial.length > 0) {
        var rowSerial = listSerial[0];
        var rowSerialNew = rowSerial;
        var customerID = (rowSerial.customer_profile_id != undefined && rowSerial.customer_profile_id != null) ? rowSerial.customer_profile_id : 0;
        rowSerialNew['warranty_status'] = warrantyStatus;
        rowSerialNew['modified_date'] = this.$myConstants.currentDate();
        rowSerialNew['organization_id'] = organizationUser;

        // thêm log thay đổi trạng thái bảo hành
        var paramsInfoLog = {request_activation_id: requestActivationID, serial_number_id: serialNumberID, old_value: JSON.stringify(rowSerial), new_value: JSON.stringify(rowSerialNew), created_date: this.$myConstants.currentDate(), modified_date: this.$myConstants.currentDate(), modifier_id: this.$store.getters.fullname.id }
        await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: paramsInfoLog})});


        var dataNewStatusChange = {
          request_activation_id: requestActivationID,
          serial_number_id: serialNumberID, 
          new_warranty_status: warrantyStatus,
          new_verify_status: rowSerial.verify_status,
          modifier_id: this.$store.getters.fullname.id,
          customer_profile_id: customerID,
          organization_id: organizationUser,
          modified_date: this.$myConstants.currentDate(),
          source: 'web'
        }
        // cập nhật trạng thái bảo hành
        await DataServices.insertData('product_serial_number_info_status_changed', {"variables": JSON.stringify({objects: dataNewStatusChange})});
      }
    },
    rejectVerify() {
      this.submitData = true;
      if (this.lstProducts.length  > 0) {
        this.rejectSubmit = false;
        this.serialnumberText = '';
        for (let index = 0; index < this.lstProducts.length; index++) {
          var item = this.lstProducts[index];
          this.serialnumberText += this.serialnumberText.length > 0 ? '<b>,</b> ' : '';
          this.serialnumberText += '<abbr> ' + item.serialNumber + '</abbr>';
        }
        this.showAcceptDialogReject = true;
      }
    },
    closeReject() {
      this.showAcceptDialogReject = false;
    },
    async processReject(info) {
      var appraisalID = info.appraisal_id;
      var serialNumberID = info.serial_number_id;
      var returnProductID = info.request_return_product_id;
      var requestActivationID = 0;
      if(info.request_return_product != undefined && info.request_return_product != null &&
      info.request_return_product.request_activation_id != undefined && info.request_return_product.request_activation_id != null) {
        requestActivationID = info.request_return_product.request_activation_id;
      }
      var noteContent = '';
      var warrantyStatus = 3;
      if (this.solution == 3) warrantyStatus = 6;
      if (this.solution == 1) noteContent = 'Từ chối và gửi trả sản phẩm cho đại lý. ' + this.noteReject;
      else if (this.solution == 2) noteContent = 'Sản phẩm cần được sửa chữa. ' + this.noteReject;
      else if (this.solution == 3) noteContent = 'Hủy sản phẩm và đổi sản phẩm mới. ' + this.noteReject;

      // chức năng tạo dịch vụ sửa chữa chưa làm this.solution == 2
      // Tạo phiếu dịch vụ sửa chữa bảo hành cho các sản phẩm đã chọn khi không duyệt
      // -------------------- TODO ---------------------

      var variables = {
        where_key: {
          appraisal_id: {'_eq': appraisalID},
          serial_number_id: {'_eq': serialNumberID}
        },
        data_update: {
          current_status: 4, // không duyệt
          note: noteContent,
          modified_date: this.$myConstants.currentDate()
        } 
      }
      var returnData  = await DataServices.updateData('appraisal_product', {"variables": JSON.stringify(variables)});
      if (returnData != null) {
        var checkData = returnData[Object.keys(returnData)];
        if (checkData.affected_rows > 0) {
          var returning = checkData.returning[0];
          var appraisalProductID = returning.id;
          if (this.solution == 3) {
            await DataServices.updateData('product_serial_number', {"variables": JSON.stringify({data_update: {warranty_status: 6}, where_key: {id: {'_eq': serialNumberID } } })});
            if (serialNumberID > 0 && requestActivationID > 0) {
              await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: {warranty_status: 6}, where_key: {serial_number_id: {'_eq': serialNumberID }, request_activation_id: {'_eq': requestActivationID} } })});

              await this.updateSerialNumberAndRequest(requestActivationID, serialNumberID, 6);

            }
          }

          await DataServices.updateData('request_return_product', {"variables": JSON.stringify({data_update: {current_status: 4}, where_key: {id: {'_eq': returnProductID}}})});
  
          var paramsProductProcess = {
              request_return_product_id: returnProductID,
              user_id: this.$store.getters.fullname.id,
              return_status: 4,
              note: noteContent,
              created_date: this.$myConstants.currentDate(),
              modified_date: this.$myConstants.currentDate(),
              warranty_status: warrantyStatus,
              appraisal_product_id: appraisalProductID
          }
          var returnDataprocess  = await DataServices.insertData('request_return_product_process', {"variables": JSON.stringify({objects: paramsProductProcess})});
          if (returnDataprocess != null) {
            var checkDataprocess = returnDataprocess[Object.keys(returnDataprocess)];
            return checkDataprocess.affected_rows > 0;
          }
        }
      }
      return false;
    },
    async acceptReject() {
      var vm = this;
      this.rejectSubmit = true;
      if (this.solution > 0 && this.lstProducts.length  > 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var k = 0;
        var stop = false;
        var list_object_id = [];
        while (k < this.lstProducts.length) {
            list_object_id.push(this.lstProducts[k].request_return_product_id);
            await this.processReject(this.lstProducts[k]);
            if (k == (this.lstProducts.length - 1)) {
                stop = true;
            }
            k++;
        }
        this.$store.commit('setLoading', false);
        if (stop) {
          await this.updateAppraisal();
          //Hủy sản phẩm và đổi sản phẩm mới => HỦy kế hoạch bảo trì định kỳ
          if (this.solution == 3){
            await this.processCancelPlanOnly(this.lstProducts);
            await vm.$coreService.sendPushNotification('appraisal_cancel_change',list_object_id)
          }else if (this.solution == 2){
          //Tạo tiếp nhận sửa chữa
          await this.processCreateWarrantyRepair();
          }else if (this.solution == 1){
            await vm.$coreService.sendPushNotification('appraisal_refuse_return_product',list_object_id)
          }
          if (this.solution == 2) this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo dịch vụ sửa chữa thành công', life: 3000 })
          else this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Thẩm định thành công', life: 3000 })
          if (this.solution == 2){
            this.showAcceptDialogReject = false;
            this.popup_confirm.showConfirmDialog = true;
          }else {
            window.location.reload();
          }
          // this.$router.push({path: '/admin/appraisal-product'});
        }
        this.$store.commit('setLoading', false);
      }
    },
    backList() {
      this.$router.push({path: '/admin/appraisal-product'});
    }
   
  }
}
</script>
<style lang="scss">
.box-top-list{ margin-bottom: 0px;
  &.last-changed{margin-bottom: 15px;}
  &.format-top{margin: 0 -1.5em; padding: 0.5em 1.5em; border-bottom: 1px solid #ccc;}
  span{font-size: 20px; text-align: left; }
  .right-button{float: right; margin-bottom: 10px;}
  .format-title{font-weight: bold; font-size: 25px;}
}
.box-info{ padding: 0 20px;
  &.list-product{margin-bottom: 30px;
    .custom-header{width: 60px !important;}
  }
  .box-info-title{ font-size: 16px; font-weight: 700; margin-bottom: 10px; margin-top: 20px;}
  .box-invoice-img{
    img{margin-right: 20px;
      &:last-child{margin: 0;}
    }
  }
  .form-info{
    .p-field{ padding: 10px; display: flex;
      &:nth-child(n) {background: #E4E4E4;}
      &:nth-child(2n) {background: #fff;}
      label{ width: 200px; margin: 0;}
      span{display: inline-flex; width: calc(100% - 220px);}
    }
  }
  &.log-changed{
    .p-datatable {
      .p-datatable-thead{
        tr {
          th {background: #169BD5;
            .p-column-title{color: #fff;}
          }
        }
      }
    }
  }
  .btn-function {margin-top: 15px;
    button{width: 170px; margin-right: 15px;}
  }
}
.dialog-reject{overflow: visible;
  .dialog-content{padding: 0 30px;
    p { margin: 0;
      .approval-title { font-size: 20px;font-weight: 700; color: #666666;}
    }
    .form-popup-custom{ font-size: 14px;
      span{font-size: 14px;
        &.info-confirm{display: block;}
        abbr{color:#0099FF; font-weight: 700;}
        &.solution-error{font-style: italic; margin-left: 10px;}
      }
    }
    .p-radiobutton {
      .p-radiobutton-box {
        &.p-highlight{ background: transparent;
          .p-radiobutton-icon{width: 14px; height: 14px; background: #007ad9; color: transparent; border-radius: 50%;
            &::before{content: normal;}
          }
        }
      }
    }
  }
  .p-dialog-footer{text-align: center; border: 0 none; padding-bottom: 20px;
    button{width: 150px; margin-right: 15px; text-transform: uppercase;
      &:last-child{margin-right: 0;}
    }
  }
}
.custom-error{display: block; color: #f00; margin-top: 10px;}
.p-field-radiobutton {margin-bottom: 0.5rem;  display: flex; align-items: center;  margin-left: 25px; width: 100%;
  label { margin-left: .5rem; line-height: 1; margin-bottom: 0;}
}

.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}
</style>